import { H2RInput, ImageUploader } from "../../imports";
import { H2RSelect } from "../../imports";
import { imageTypesDefinitions } from "../../imports";
import { ImagePreview, TextArea } from "../FormElements";
import { H2RButton } from "../../imports";
import { useSelector } from "react-redux";
import { ReplaceWithDataSource } from "../helpers/variable";
import { faDownLeftAndUpRightToCenter, faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons";

export const GraphicEditor = ({ cue, media, onUpdate}) => {
	const cloud = useSelector((state) => state.rundown.cloud) || false;
	return (
		<>
			<H2RSelect
				label="Looping"
				selected={cue.loop || "looping"}
				css="mb-2"
				options={[
					{ label: "Loop forever", value: "looping" },
					{ label: "Play once", value: "once" },
					{ label: "Manual", value: "manual" },
				]}
				onChange={(change) => {
					onUpdate({ loop: change });
				}}
			/>
			<H2RInput
				placeholder="5"
				value={cue.timePerSection || 5}
				label="Time per section (seconds)"
				type="number"
				min="1"
				max="1000"
				onChange={(change) => {
					if (change < 0) return null;
					return onUpdate({ timePerSection: change });
				}}
			/>
			<H2RSelect
				label="Section count"
				selected={cue.count || 3}
				css="mb-2"
				options={[
					{ label: "1 section", value: 1 },
					{ label: "2 sections", value: 2 },
					{ label: "3 sections", value: 3 },
				]}
				onChange={(change) => {
					onUpdate({ count: change });
				}}
			/>

			{cue.items.map((t, i) => {
				if (i + 1 > parseInt(cue.count || 3)) return null;
				return (
					<div key={i}>
						<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>
						<span>Section {i + 1}</span>
						<div className="mb-4 flex flex-col max-w-sm">
							<div className="flex max-w-sm space-x-3">
								<H2RInput
									label={`Section title (Large text)`}
									placeholder="Section Title"
									value={t.sectionTitle}
									onChange={(value) => {
										onUpdate({
											items: [
												...cue.items.map((t, id) => {
													if (id === i) {
														return {
															...t,
															sectionTitle: value,
														};
													} else {
														return t;
													}
												}),
											],
										});
									}}
								/>
							</div>
							<div className="flex max-w-sm space-x-3">
								<H2RInput
									label={`Title (Large text)`}
									placeholder="Title"
									value={t.title}
									onChange={(value) => {
										onUpdate({
											items: [
												...cue.items.map((t, id) => {
													if (id === i) {
														return {
															...t,
															title: value,
														};
													} else {
														return t;
													}
												}),
											],
										});
									}}
								/>
							</div>

							<div className="flex mt-2 flex-col space-y-2 max-w-sm">
								<TextArea
									label={`Description (Small text)`}
									placeholder="Description"
									value={t.description}
									rows="2"
									onChange={(value) => {
										onUpdate({
											items: [
												...cue.items.map((t, id) => {
													if (id === i) {
														return {
															...t,
															description: value,
														};
													} else {
														return t;
													}
												}),
											],
										});
									}}
								/>
							</div>

							<div className="flex flex-col space-y-2">
								{cloud ? (
									<H2RInput
										label="Image URL"
										value={t.url}
										placeholder={`https://media.h2r.graphics/image.png`}
										onChange={(change) => {
											onUpdate({
												items: [
													...cue.items.map((t, id) => {
														if (id === i) {
															return {
																...t,
																url: change,
															};
														} else {
															return t;
														}
													}),
												],
											});
										}}
									/>
								) : (
									<div className="flex space-x-1 justify-end items-end">
										<H2RSelect
											selected={t.image}
											label="Section image"
											options={
												media.length === 0
													? [
															{
																label: "Add images in the Media tab",
																value: ``,
																disabled: true,
															},
													  ]
													: [
															{
																label: "None",
																value: "none",
															},
															...media
																.filter((item) =>
																	imageTypesDefinitions.includes(item?.mimetype)
																)
																.map((item) => {
																	return {
																		label: item.originalname,
																		value: item.filename,
																	};
																}),
													  ]
											}
											onChange={(value) => {
												onUpdate({
													items: [
														...cue.items.map((t, id) => {
															if (id === i) {
																return {
																	...t,
																	image: value,
																};
															} else {
																return t;
															}
														}),
													],
												});
											}}
										/>
										<H2RButton
											text=""
											colour="dark"
											icon={
												t.imageFit === "contain"
													? faUpRightAndDownLeftFromCenter
													: faDownLeftAndUpRightToCenter
											}
											size="small"
											onClick={() => {
												onUpdate({
													items: [
														...cue.items.map((t, id) => {
															if (id === i) {
																return {
																	...t,
																	imageFit:
																		t.imageFit === "contain"
																			? "cover"
																			: "contain",
																};
															} else {
																return t;
															}
														}),
													],
												});
											}}
										/>
									</div>
								)}
								{cloud ? 
									<ImageUploader cue={cue} onUpdate={(url)=> {
										onUpdate({
											items: [
												...cue.items.map((t, id) => {
													if (id === i) {
														return {
															...t,
															url,
														};
													} else {
														return t;
													}
												}),
											],
										});
									}} />
								:
									<ImagePreview image={cue.filename} />
								}
							</div>
						</div>
					</div>
				);
			})}
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">
				<ReplaceWithDataSource
					text={cue.items?.[0]?.title}
					keepBrakets={true}
				/>
				,{" "}
				<ReplaceWithDataSource
					text={cue.items?.[1]?.title}
					keepBrakets={true}
				/>
				,{" "}
				<ReplaceWithDataSource
					text={cue.items?.[2]?.title}
					keepBrakets={true}
				/>
			</span>
		</div>
	);
};
